import FightQueueStatus from './components/FightQueueStatus';
import { QueueOverviewProvider } from './context/QueueOverviewContext';
import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { WebSocketProvider } from './context/WebSocketContext';
import { ThemeProvider } from './context/ThemeContext';
import GlobalStyles from './styles/GlobalStyles';
import AppRoutes from './routes';

const App = () => {
  useEffect(() => {
    // 预加载字体
    const preloadFont = async () => {
      if ('fonts' in document) {
        try {
          await document.fonts.load('1em HanaMinA');
          // 字体加载完成后，添加class标记
          document.documentElement.classList.add('fonts-loaded');
        } catch (err) {
          console.error('Font loading failed:', err);
        }
      }
    };

    preloadFont();

    // 添加视口高度修复（解决移动端100vh问题）
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    
    // 添加全局音频解锁功能
    const unlockAudio = () => {
      const audioElement = document.getElementById('timer-sound');
      if (audioElement) {
        console.log('尝试全局解锁音频播放');
        audioElement.volume = 0.01;
        audioElement.play()
          .then(() => {
            console.log('全局音频解锁成功');
            audioElement.pause();
            audioElement.currentTime = 0;
            // 添加标记表示已解锁
            window.audioUnlocked = true;
          })
          .catch(err => {
            console.log('全局音频解锁失败:', err);
          });
      }
    };
    
    // 全局交互事件监听，用于解锁音频
    const handleUserInteraction = () => {
      document.body.setAttribute('data-user-interacted', 'true');
      unlockAudio();
    };
    
    // 添加音频解锁的交互监听
    const events = ['click', 'touchstart', 'keydown', 'scroll'];
    events.forEach(event => {
      document.addEventListener(event, handleUserInteraction, { once: true });
    });
    
    // 每次切换到页面时也尝试解锁
    window.addEventListener('focus', unlockAudio);
    
    // 直接尝试解锁一次
    unlockAudio();
    
    // 定期检查音频状态，如果没解锁就尝试解锁
    const checkInterval = setInterval(() => {
      if (!window.audioUnlocked) {
        unlockAudio();
      } else {
        clearInterval(checkInterval);
      }
    }, 2000);

    return () => {
      window.removeEventListener('resize', setVH);
      events.forEach(event => {
        document.removeEventListener(event, handleUserInteraction);
      });
      window.removeEventListener('focus', unlockAudio);
      clearInterval(checkInterval);
    };
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <UserProvider>
          <WebSocketProvider>
            <QueueOverviewProvider>
            <Router>
              <GlobalStyles />
              <FightQueueStatus />
              <div className="force-gpu">
                <AppRoutes />
              </div>
            </Router>
            </QueueOverviewProvider>
          </WebSocketProvider>
        </UserProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App; 
